import cyclone from "../Assets/Cyclone victims.jpeg"
import cyclone1 from "../Assets/cyclone1.jpg"
import cyclone2 from "../Assets/cyclone2.jpg"
import school from "../Assets/school1.jpg"
import school2 from "../Assets/school2.jpg"
import katina from "../Assets/katin civara dana.jpeg"
import aware from "../Assets/awareness1.jpeg"
// First Slider  
export const FirstSlideItems=[
    {
        id:1,
        img:cyclone,
        title:'CYCLONE VICTIM',
        desc:`This is the first social work of dmws, the cyclone hit in the month of april 2022 in Arunachal Pradesh hich has affected many families in diyun circles many became victims of that cyclone.`,
        bg:'f5fafd'
    },
    {
        id:2,
        img:katina,
        title:'KATINA CIVARA DHANA',
        desc:`We dmws by collaborating with acsa organized Katina Civara dhana at aurangabad maharashtra, India on date 25/10/2021`,
        bg:'fcf1ed'
    },
   
    {
        id:3,
        img:aware,
        title:'AWARENESS PROGRAM',
        desc:`DMWS is an organisation of awareness, promoting education, doing social work, most of the students stuck in their secondary and higher secondary schooling they don't...`,
        bg:'fcf1ed'
    },
    
]
// Second Sliders
export const SecondSliderItems=[
    {
        id:1,
        img:school2,
    },
    {
        
        id:2,
        img:cyclone,
    },
    {
        id:3,
        img:aware,
    },
    {
        id:4,
        img:cyclone1
    },
    {
        id:5,
        img:school
    },
    {
        id:6,
        img:cyclone2
    }


]
// Home Page Data

export const HomePageData=[
    {
        id:1,
        title:'Who We Are',
        img:'',
        content:`"DHAMMA METTA WELFARE SOCIETY" is a non-governmental organisation(NGO) which was established in the year 2019 with a mission and vision to provide humanitarian services to the vulnerable section of the society irrespective of any religion including education to the underprivileged children's, providing health care, empowering individual and communities to become self-reliant and empowering women and address the inequalities facing by girls and women.

        Our major focus is on education to the underprivileged children. Education is the mirror of society and the seed of socio-economic development. We believe that the children's of today's generation is the future of every country. Every children's deserves a good and quality education but unfortunately children's of the poor parents and remote areas are deprived of quality education even the local government do not pay attention to them. We DHAMMA METTA WELFARE SOCIETY are committed and dedicated towards education to the underprivileged children. Our ambition is to make their life better and meaningful by providing moral and quality education.`
    },
    {
        id:2,
        title:'What We Do',
        img:'',
        content:`Education
        Education is the most precious gift we can offer to the children's. DHAMMA METTA WELFARE SOCIETY as an organization priorities to education especially to the underprivileged children's. Children has the right to education, indeed it is a fundamental right to the children's however, many parents fail to provide education to their children owing to poverty , Likewise the dream of many children's remain unfulfilled. Children's of remote areas are the victim of poverty. They are ever neglected and remain deprived as always. We as a team firmly believe that Education is the only tool to eradicate poverty and change the life of many Children's by providing a quality education. Let us join and help Dhamma Metta Welfare Society by way of monetary support to change the life of underprivileged children's.
        
        Emergency Relief
        Dhamma Metta welfare society alway come forward with the support from Donor's, kind-hearted person to provide emergency relief to the victims of any unfortunate events. Service to mankind is greatest wholesome deed, wherever and whenever is possible Dhamma Metta welfare society as a team always extend their helping hand during the crisis.`
    }
]
// Work Data
export const WorkData=[
    {
        id:1,
        title:'First social work of dmws for cyclone victim',
        img:cyclone,
        content:`This is the first social work of dmws, the cyclone hit in the month of april 2022 in Arunachal Pradesh which has affected many families in diyun circles many became victims of that cyclone. we dmws by the guidance of most respected venerable Sadananda had raise funds and contributed from our own pocket and distributed rations to the victims. We thanks bhante Sadananda for guiding us and contributing financially and all the donors we came forward and contributed for this Noble deeds and special thanks to volunteers who took the initiative to distribute the ration at ground.`
    },
    {
        id:2,
        title:'Awareness Program',
        img:aware,
        content:`Dmws is an organisation of awareness, promoting education, doing social work, most of the students stuck in their secondary and higher secondary schooling they don't know what to do next, by keeping that in mind we dmws organized career counseling motivational seminar to the underprivileged students and guide them for their better future.`  
    }
    ,{
        id:3,
        title:'Katina Civara Dhana',
        img:katina,
        content:`We dmws by collaborating with acsa organized Katina Civara dhana at aurangabad maharashtra, India on date 25/10/2021. Katina Civara dhana is a religious function in Buddhist culture which is celebrated whole over the world. After the establishment of dmws it is our first religious function.`
    }
]